import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const MulJudges = () => {
    const navigate = useNavigate();
    const [judges, setJudges] = useState([]);

    const fetchJudges = () => {
        Axios.post(
            "https://ashish.moodi.org/multicity/get_mul_judges",
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => setJudges(res.data))
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (localStorage.getItem("compiauthtoken")) {
            fetchJudges();
        } else {
            navigate("/admin/login");
        }
    }, []);

    return (
        <div className="container-fluid">
            <div className="row">
                <h2 className="col-6">Multicity Judges</h2>
                <Link
                    to="/admin/multicity/add_judge"
                    className="col-2 btn btn-primary"
                >
                    Add Judge
                </Link>
            </div>
            <table className="container">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Password</th>
                        <th>Phone Number</th>
                    </tr>
                </thead>
                <tbody>
                    {judges.map((judge) => {
                        return (
                            <tr>
                                <td>{judge.mcJudgeName}</td>
                                <td>{judge.mcJudgeEmail}</td>
                                <td>{judge.mcJudgePassText}</td>
                                <td>{judge.mcJudgePhone}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default MulJudges;
